<template>
  <button
    :aria-label="$t('AI_AGENTS.FILE_UPLOAD.ATTACH_FILE')"
    class="p-2 text-disabled-medium disabled:opacity-50"
    :class="{ 'hover:text-primary': !disabled }"
    :disabled
    data-cy="chat-attach-button"
    @click="handleAttach()"
  >
    <icon-base
      v-tooltip="$t('AI_AGENTS.FILE_UPLOAD.ATTACH_FILE')"
      :icon="IconAttach"
      width="24"
      height="24"
      view-box="0 0 22 22"
    />
  </button>
</template>
<script setup lang="ts">
import { useFileDialog } from "@vueuse/core";

import { useFiles } from "@/stores/ai/files";

import IconAttach from "@/components/icons/IconAttach.vue";

const { disabled } = defineProps<{ disabled: boolean }>();
const { allowedDocTypes, handleFileUpload } = useFiles();

const { open: handleAttach, onChange } = useFileDialog({
  accept: allowedDocTypes.join(","),
  multiple: true,
});

onChange(handleFileUpload);
</script>
